import React from 'react';
import logo from './auxmod_logo.svg';
import display_1 from './display_1.svg';
import display_2 from './display_2.svg';
import cloud from './cloud.svg';

const LandingDesktop = () => {

  return (
    <div className="container-fluid vh-100 position-relative overflow-hidden p-0">
      {/* Logo */}
      <div className="position-absolute" style={{ top: '16px', left: '16px', zIndex: 5, maxWidth: '100px' }}>
        <div className="d-flex flex-column text-center">
          <img width="100%" src={logo} alt="auXmod logo" />
          <h5 className="font-weight-normal text-dark">auXmod</h5>
        </div>
      </div>

      <div className="row h-100 mt-5 ml-5">
        {/* Main content - left side */}
        <div className="col-md-6 d-flex flex-column justify-content-center align-items-center text-center position-relative px-4" style={{ zIndex: 1 }}>
  <h1 className="font-weight-medium" style={{ fontSize: '3rem' }}>Cleanify is now auXmod!</h1>
  <div className="mt-3">
    <h5 className="font-weight-light" style={{ fontSize: '1.25rem' }}>
      Loved Cleanify? You'll love auXmod even more. Automatically replace songs with clean versions plus theme-based moderation to ensure playlists are perfect for any space.
    </h5>
    
    <div className="row mt-4">
      <div className="col-md-6">
        <div className="p-3 h-100 border-right">
          <h6 className="font-weight-bold">What hasn't changed:</h6>
          <p className="text-center">
            auXmod still automatically replaces explicit songs with their clean versions when you select the Profanity filter—just like Cleanify always did.
          </p>
        </div>
      </div>
      <div className="col-md-6">
        <div className="p-3 h-100">
          <h6 className="font-weight-bold">What's new:</h6>
          <p className="text-center">
            Filter based on themes like violence & sexual content and whitelist words, providing more control over what's appropriate for your space.
          </p>
        </div>
      </div>
    </div>
  </div>
  
  <div className="d-flex justify-content-center mt-4">
    <a href="https://auxmod.netlify.app/app" className="btn btn-warning rounded-pill px-4 py-2" style={{ fontSize: '1.1rem',backgroundColor:'#FFD8A8'  }}>
      Try now!
    </a>
    <a href="https://auxmod.netlify.app/" className="btn btn-warning rounded-pill px-4 py-2" style={{ fontSize: '1.1rem', backgroundColor:'#FFD8A8' }}>
      Learn More
    </a>
  </div>
</div>

        {/* Right side with images */}
        <div className="col-md-6 position-relative">
          {/* This column will contain the overlapping images */}
        </div>
      </div>


      {/* Background circle */}
      <div 
        className="position-absolute"
        style={{
          top: '50%',
          right: '-25%',
          width: '70vw',
          height: '70vw',
          transform: 'translateY(-50%)',
        //   background: 'linear-gradient(180deg, #fceabb, #FFD8A8)',
          zIndex: 0,
        }}
      />

      {/* Display images */}
      <div 
        className="position-absolute"
        style={{
          top: '50%',
          right: '10%',
          transform: 'translateY(-50%)',
          height: '60vh',
          width: '25%',
          zIndex: 1,
          pointerEvents: 'none'
        }}
      >
        {/* Container for the overlapping images */}
        <div className="position-relative h-100 w-100">
          {/* smaller display (display_1) */}
          <div
            className="position-absolute"
            style={{
              width: '75%',
              left: '-2vw',
              top: '50%',
              transform: 'translateY(-50%)',
            }}
          >
            <img 
              src={display_1} 
              alt="Display 1"
              className="img-fluid rounded"
              style={{
                maxHeight: '70vh',
                objectFit: 'contain',
              }}
            />
          </div>
          {/* larger display (display_2) */}
          <div
            className="position-absolute"
            style={{
              width: '80%',
              right: '-8vw',
              top: '50%',
              transform: 'translateY(-50%)',
            }}
          >
            <img 
              src={display_2} 
              alt="Display 2"
              className="img-fluid rounded"
              style={{
                maxHeight: '70vh',
                objectFit: 'contain',
              }}
            />
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="position-fixed" style={{ bottom: 0, left: 0, padding: '0.5rem', zIndex: 2 }}>
        <small className="text-muted">© 2025 auXmod. Created by Briana King.</small>
      </div>

    </div>
  );
};

export default LandingDesktop;